'use strict';

const base = require('wishlist/product/wishlist');

/*
    - Method below copied from source in plugin_wishlists wishlistHeart.js since that
    plugin does not export the function to be able to be called from base.*
    - This is used on the PDP to display a message and change the icon when a product is added to the wishlist.
    - This is not used in the product tile, which uses the wishlistHeart.js file in the plugin_wishlists
    - This is a custom change to the original plugin_wishlists functionality.
 */

function displayMessage(data, button, icon) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';

        // Adding same functionality to change heart icon as in wishlistHeart.js
        if (icon.hasClass('fa-heart-o')) {
            icon.removeClass('fa-heart-o').addClass('fa-heart');
        }
    } else {
        status = 'alert-danger';

        // Adding same functionality to change heart icon as in wishlistHeart.js
        if (icon.hasClass('fa-heart-o') && data.found) {
            icon.removeClass('fa-heart-o').addClass('fa-heart');
        }
    }

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append(
            '<div class="add-to-wishlist-messages "></div>'
        );
    }

    $('.add-to-wishlist-messages')
        .append('<div class="add-to-wishlist-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
        button.removeAttr('disabled');
    }, 5000);
}

function addToWishlist() {
    $('.add-to-wish-list').on('click', function (e) {
        e.preventDefault();
        var icon = $(this).find($('i'));
        var url = $(this).data('href');
        var button = $(this);
        var pid = $(this).closest('.product-detail').find('.product-id').html();

        // If this is PDP, check a different div
        if (!pid) {
            pid = $(this).closest('.product-detail').data('pid');
        }

        var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
        var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
        optionId = optionId || null;
        optionVal = optionVal || null;
        if (!url || !pid) {
            return;
        }

        $.spinner().start();
        $(this).attr('disabled', true);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                pid: pid,
                optionId: optionId,
                optionVal: optionVal
            },
            success: function (data) {
                if (data.redirectlink) {
                    window.location = data.redirectlink;
                } else {
                    displayMessage(data, button, icon);
                }
            },
            error: function (err) {
                displayMessage(err, button, icon);
            }
        });
    });
}

// Export overridden function
module.exports = $.extend({}, base, {
    addToWishlist
});